import angular from 'angular';
import portaro from '../portaro';
import {responseToData} from 'shared/utils/data-service-utils';

portaro.factory('tenderService', ['CONTEXT_PATH', '$resource', '$http', '$timeout', 'fileUploadService',
    function(CONTEXT_PATH, $resource, $http, $timeout, fileUploadService) {

        class OfferingState {
            constructor(offeringStateDto) {
                this.steps = offeringStateDto.steps
                    .map(backendStep => {
                        const step = {
                            type: backendStep.type,
                            isDone: () => backendStep.done,
                            isFeasible: () => backendStep.feasible,
                            isActive: () => !step.isDone() && this.getRemainingSteps().length > 0 && this.getRemainingSteps()[0] === step
                        };

                        if (step.type === 'TERMS_AND_CONDITIONS_ACCEPT') {
                            step.checks = [backendStep.done, backendStep.done, backendStep.done];
                            step.isDone = () => backendStep.done || step.checks.every(v => v);
                        }

                        if (step.type === 'AGREEMENT_FILE_DOWNLOAD') {
                            step.clicked = false;
                            step.isDone = () => backendStep.done || step.clicked;
                            step.isActive = () =>
                                (!step.isDone() && this.getRemainingSteps().length > 0 && this.getRemainingSteps()[0] === step) ||
                                (step.isDone() && this.getRemainingSteps().filter(step => step.type === 'SIGNED_AGREEMENT_FILE_UPLOAD').length > 0)
                        }

                        if (step.type === 'AGREEMENT_CONFIRM') {
                            step.clicked = false;
                            step.isDone = () => backendStep.done || step.clicked;
                        }

                        return step;
                    });
                this.getStepOfType = (stepType) => this.steps.filter(step => step.type === stepType)[0];
                this.getRemainingSteps = () => this.steps.filter(step => !step.isDone());
            }
        }

        const getOfferingStates = function (tender, user) {
            const activeUserId = user.role.includes('ROLE_SUPPLIER') ? user.id : null;
            return $http.get(`${CONTEXT_PATH}/api/tenders/${tender.id}/offering-states?supplier=${activeUserId || ''}`)
                .then(responseToData)
                .then(agreementDtos => agreementDtos.map(agreementDto => new OfferingState(agreementDto)));
        };

        const confirmAgreement = function (tender, supplierUser) {
            return $http.get(`${CONTEXT_PATH}/api/tenders/${tender.id}/agreements/confirm?supplier=${supplierUser.id}`)
                .then(responseToData)
        };

        const uploadAgreement = function (tender, supplierUser, file) {
            return fileUploadService.upload(`${CONTEXT_PATH}/api/tenders/${tender.id}/agreements/signed?supplier=${supplierUser.id}`, file);
        };

        const query = function (obj) {
            return $http.get(`${CONTEXT_PATH}/api/tenders`, {params: obj})
                .then(responseToData)
                .then((tenders) => {
                    angular.forEach(tenders, fillTender);
                    return tenders;
                });
        };

        const getById = function (id) {
            return $http.get(`${CONTEXT_PATH}/api/tenders/${id}`)
                .then(responseToData)
                .then(fillTender);
        };

        function fillTender(tender) {
            const currentTime = new Date();
            const endTime = new Date(tender.endDate);
            const startTime = new Date(tender.startDate);
            const openTime = new Date(tender.openDate);

            if (currentTime > endTime) {
                tender.phase = "FINISHED";
            } else if (currentTime > startTime) {
                tender.phase = "STARTED";
            } else if (currentTime > openTime) {
                tender.phase = "OPENED";
            } else {
                tender.phase = "CREATED";
            }

            function setChangePhaseAfterDelay(tender, delay, finalPhase) {
                if (delay > 0) {
                    if (delay <= 0x7FFFFFFF) {
                        console.log("TENDER", tender.id, "delay", Math.round(delay/1000), "seconds for change phase to", finalPhase);
                        $timeout(function() {
                            tender.phase = finalPhase;
                            console.log("TENDER", tender.id, "setting phase to", tender.phase);
                        }, delay);
                    } else {
                        console.log("TENDER", tender.id, "delay for change phase to", finalPhase, "is very large");
                    }
                }
            }

            const delayToOpen = openTime - currentTime;
            setChangePhaseAfterDelay(tender, delayToOpen, "OPENED");

            const delayToStart = startTime - currentTime;
            setChangePhaseAfterDelay(tender, delayToStart, "STARTED");

            const delayToFinish = endTime - currentTime;
            setChangePhaseAfterDelay(tender, delayToFinish, "FINISHED");

            console.log("TENDER", tender.id, "phase", tender.phase);

            return tender;
        }

        return {
            query: query,
            getById: getById,
            getOfferingStates: getOfferingStates,
            uploadAgreement: uploadAgreement,
            confirmAgreement: confirmAgreement
        };
    }]);